import { Optional } from '@whistler-ui/k2/types/common';

import {
  REJECTED_STATUS,
  REVIEWING_STATUS,
} from '../../constants/businessConstants';

export const isInvalidOrganisation = (orgStatus: string): Optional<string> => {
  return REVIEWING_STATUS[orgStatus] || REJECTED_STATUS[orgStatus];
};
